import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from '../../util/Api';

import {
    CREATE_JOB_CARD_SUCCESS,
    FETCH_JOB_CARD_REPORT_SUCCESS,
    FETCH_JOB_CARD_SEARCH_SUCCESS,
    FETCH_JOB_CARD_SUCCESS,
    GET_ALL_JOBS_START,
    // GET_IOT_JOB_CARD_SUCCESS,
    // SAVE_IOT_JOB_CARD_QUERY,
    GET_ALL_JOBS_SUCCESS,
    GET_ALL_OPEN_JOBS_SUCCESS,
    GET_COMPLAINT_DATA_SUCCESS,
    GET_JOB_CARD_DASHBOARD_DOWNLOAD_START,
    GET_JOB_CARD_DASHBOARD_DOWNLOAD_SUCCESS,
    GET_JOB_CARD_SUCCESS,
    GET_LOCATION_BY_QUERY,
    SAVE_JOB_CARD_QUERY,
    UNMOUNT_JOB_CARD,
    FETCH_JOB_CARD_COSTING_REPORT_SUCCESS,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import { downloadProgress, fetchError, fetchStart, fetchSuccess } from './Common';
import { downloadCSV, sanitizeFieldName } from "../../util/methods";
import * as moment from "moment";

import React from "react";
import { message, notification, Typography } from "antd";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

const { Text, Title, Paragraph } = Typography;

export function arrayToCSV(input, filter, selectedColumns, columns) {
    // console.log(input, filter, selectedColumns, columns);
    var CSV_SEPARATOR = ';';
    var headers = getHeaders(input, columns);
    var lines = getLines(input, headers);

    for (let i in headers) {
        if (headers[i] === "client") {
            headers[i] = "subLocation";
        }
        if (headers[i] === "equipmentSubType") {
            headers[i] = "assetSubType";
        }
        if (headers[i] === "statusTitle") {
            headers[i] = "Pending Invoice";
        }
        headers[i] = sanitizeFieldName(headers[i]);
    }

    return [headers.join(CSV_SEPARATOR)].concat(lines).join('\n');

    function getRenderForFieldByTypeForCsv(value, type) {
        // console.log(type);
        switch (type) {
            case 'String':
                return value || '--';
            case 'Date':
                return value ? moment(value || '').format('DD-MM-YYYY hh:mm a') : '--';
            case 'ObjectID':
                if (Array.isArray(value)) {
                    return value.map(item => item.name).join(',');
                }

                if (value && value.name) {
                    return value.name;
                }

                if (value && value.assetCode) {
                    return value.assetCode;
                }

                if (value && value.ownerCode) {
                    return value.ownerCode;
                }

                if (value && value.complaintNo) {
                    return value.complaintNo;
                }

                return value || "--";
            default:
                return value || "--";
        }
    }


    function getHeaders(input, columns) {
        var headers = new Set();
        columns = JSON.parse(columns);
        columns.map(key => {
            if (key === 'assetSubType') {
                headers.add('assetSubType');
            }
            if (key === 'subLocation') {
                headers.add('client');
            }
            if (key === 'assetLinkedParent') {
                headers.add('parent');
            }
            if (key === 'location') {
                headers.add('location');
            }
            if (key === 'assetCode') {
                headers.add('assetCode');
            }
            if (key === 'ownerCode') {
                headers.add('ownerCode');
            }
            if (key === 'assetType') {
                headers.add('assetType');
            }
            if (key === 'owner') {
                headers.add('owner');
            }
            if (key === 'complaintDate') {
                headers.add('complaintDate');
            }
            if (key === 'presentStatus') {
                headers.add('presentStatus');
            }
            if (key === 'presentStatusRemark') {
                headers.add('presentStatusRemark');
            }
            if (key === 'totalAmount') {
                headers.add('totalAmount');
            }
            if (key === 'detailsOfComplaint') {
                headers.add('detailsOfComplaint');
            }
            if (key === 'causeOfDamage') {
                headers.add('causeOfDamage');
            }
            if (filter[key] && filter[key].type && filter[key].type !== 'Array') {
                headers.add(key);
            }
        });
        return Array.from(headers);
    }

    function getLines(input, headers) {
        return input.map(function (obj) {
            return headers.map(function (head) {
                let val = null;
                if (head !== "location" && head !== 'causeOfDamage' && head !== 'detailsOfComplaint' && head !== 'totalAmount' && head !== 'presentStatus' && head !== 'presentStatusRemark' && head !== "assetCode" && head !== "ownerCode" && head !== "client" && head !== "assetSubType" && head !== "assetType" && head !== "owner" && head !== 'complaintDate') {
                    val = getRenderForFieldByTypeForCsv(obj[head], filter[head].type);
                } else {
                    if (head === "assetCode") {
                        val = getRenderForFieldByTypeForCsv(obj['complaint']['asset'], "ObjectID");
                    }
                    if (head === "ownerCode") {
                        val = getRenderForFieldByTypeForCsv(obj['complaint']['asset']['ownerCode'], "ObjectID");
                    }
                    if (head === "assetSubType") {
                        val = getRenderForFieldByTypeForCsv(obj['complaint']['asset']['equipmentSubType'], "ObjectID");
                    }
                    if (head === "assetType") {
                        val = getRenderForFieldByTypeForCsv(obj['complaint']['asset']['equipmentSubType']['assetType'], "ObjectID");
                    }
                    if (head === "location") {
                        val = getRenderForFieldByTypeForCsv(obj['complaint']['location'], "ObjectID");
                    }
                    if (head === "client") {
                        val = getRenderForFieldByTypeForCsv(obj['complaint']['client'], "ObjectID");
                    }
                    if (head === "owner") {
                        val = getRenderForFieldByTypeForCsv(obj['complaint']['asset']['owner'], "ObjectID");
                    }
                    if (head === "complaintDate") {
                        val = getRenderForFieldByTypeForCsv(obj['complaint']['complaintDate'], "Date");
                    }
                    if (head === "presentStatus") {
                        val = getRenderForFieldByTypeForCsv(obj.presentStatus || ' ', "String");
                    }
                    if (head === "presentStatusRemark") {
                        val = getRenderForFieldByTypeForCsv(obj.presentStatusRemark || ' ', "String");
                    }
                    if (head === "totalAmount") {
                        val = getRenderForFieldByTypeForCsv(obj.totalAmount || ' ', "Number");
                    }
                    if (head === "detailsOfComplaint") {
                        val = getRenderForFieldByTypeForCsv(obj['complaint']['detailsOfComplaint'] || ' ', "String");
                    }
                    if (head === "causeOfDamage") {
                        val = getRenderForFieldByTypeForCsv(obj['complaint']['causeOfDamage'] || ' ', "String");
                    }
                }
                return (val || '');
            }).join(CSV_SEPARATOR);
        });
    }
}

export const getResourceSuccess = ({ data, count }) => {
    return {
        type: GET_JOB_CARD_SUCCESS,
        data,
        count,
    };
};

// export const getJobCardsSuccess = ({ data, count }) => {
//   return {
//     type: GET_JOB_CARD_FROM_JOB_ALLOCATION,
//     data,
//     count,
//   };
// };

export const saveResourceQuery = (query) => {
    return {
        type: SAVE_JOB_CARD_QUERY,
        query,
    };
};

export const createResourceSuccess = ({ data }) => {
    return {
        type: CREATE_JOB_CARD_SUCCESS,
        data,
    };
};

export const fetchResourceSuccess = ({ data }) => {
    return {
        type: FETCH_JOB_CARD_SUCCESS,
        data,
    };
};

export const fetchSearchResourceSuccess = ({ data }) => {
    return {
        type: FETCH_JOB_CARD_SEARCH_SUCCESS,
        data,
    };
};

export const fetchReportSuccess = ({ data }) => {
    return {
        type: FETCH_JOB_CARD_REPORT_SUCCESS,
        data,
    };
};

export const clearProps = () => {
    return {
        type: UNMOUNT_JOB_CARD,
    }
};

export const getLocationByQuerySuccess = ({ data }) => {
    return {
        type: GET_LOCATION_BY_QUERY,
        data,
    };
};

export const getComplaintDataSuccess = (data) => {
    return {
        type: GET_COMPLAINT_DATA_SUCCESS,
        data,
    };
};


export const getLocationByQuery = (locationQuery) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/location?locationQuery=${locationQuery}`);
            dispatch(fetchSuccess());
            dispatch(getLocationByQuerySuccess(response.data));
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log('Error****:', error.response.data.message);
        }
    };
};

export const getComplaintData = (id) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/job-card/search-by-location?locationQuery=${id}`);
            dispatch(fetchSuccess());
            dispatch(getComplaintDataSuccess(response.data));
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log('Error****:', error.response.data.message);
        }
    };
};

export const getResource = () => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const { jobCard } = store.getState();
            const { query } = jobCard;
            const response = await axios.get(`/job-card?${generateQueryString(query)}`);
            dispatch(fetchSuccess());
            dispatch(getResourceSuccess(response.data));
        } catch (error) {
            const dbQuery = {
                "sort": {
                    "field": "",
                    "order": ""
                },
                "pagination": {
                    "pageSize": 10,
                    "current": 1,
                    "total": 249
                },
                "filters": {
                    "status": "",
                    "jobCardNo": ""
                }
            }
            dispatch(saveResourceQuery(dbQuery));
            // message.error(error.response.data.message);
            message.error("Record not found...!");
            dispatch(fetchError(error.response.data.message));
            console.log('Error****:', error.response.data.message);
        }
    };
};

// export const getIotResource = () => {
//     return async (dispatch) => {
//         dispatch(fetchStart());
//         try {
//             const { jobCard } = store.getState();
//             const { query } = jobCard;
//             console.log('query:', query)
//             const response = await axios.get(`/job-card/in-organisation?${generateQueryString(query)}`);
//             console.log('response:', response.data)
//             dispatch(fetchSuccess());
//             dispatch(getIotResourceSuccess(response.data));
//         } catch (error) {
//             const dbQuery = {
//                 "sort": {
//                     "field": "",
//                     "order": ""
//                 },
//                 "pagination": {
//                     "pageSize": 10,
//                     "current": 1,
//                     "total": 249
//                 },
//                 "filters": {
//                     "status": "",
//                     "jobCardNo": ""
//                 }
//             }
//             dispatch(saveIotResourceQuery(dbQuery));
//             // message.error(error.response.data.message);
//             message.error("Record not found...!");
//             dispatch(fetchError(error.response.data.message));
//             console.log('Error****:', error.response.data.message);
//         }
//     };
// };

// export const getIotResourceSuccess = ({ data }) => {
//     return {
//         type: GET_IOT_JOB_CARD_SUCCESS,
//         data,
//     };
// };


// export const saveIotResourceQuery = (query) => {
//     return {
//         type: SAVE_IOT_JOB_CARD_QUERY,
//         query,
//     };
// };


export const getResourceForDownload = (columns, filters, selectedColumns, name) => {
    return async (dispatch) => {

        dispatch(fetchStart());
        try {
            const { jobCard } = store.getState();
            const { query } = jobCard;
            const response = await axios.get(`/job-card/download?columns=${columns}&${generateQueryString(query)}`,
                {
                    responseType: 'stream',
                    onDownloadProgress: function (progressEvent) {
                        dispatch(downloadProgress(progressEvent.total, ((progressEvent.loaded / 1024) / 1024).toFixed(2)));
                    },
                });
            dispatch(downloadProgress(0, 0));
            let newResponse = [];
            if (response && response.data) {

                newResponse = await axios.post(`job-card/setLocation`, response.data);
                const itemProm = newResponse.data && newResponse.data.map(async item => {
                    if (item.changeStatus) {
                        let length = item.changeStatus && item.changeStatus.length;
                        item['presentStatus'] = (item.changeStatus && item.changeStatus.length > 0) ?
                            item.changeStatus[length - 1].status.name : '-';
                        item['presentStatusRemark'] = (item.changeStatus && item.changeStatus.length > 0) ?
                            item.changeStatus[length - 1].details : '-';
                        // delete item['changeStatus'];
                    }
                    if (item && item.complaint) {
                        item['assetUnservicable'] = item.complaint.assetUnservicable ? true : false;
                    }
                    return true;
                });
                await Promise.all(itemProm);
            }
            dispatch(fetchSuccess());
            filters['assetUnservicable'] = { field: 'assetUnservicable', type: 'Boolean' };
            // console.log('newResponse:', newResponse['data'])
            const str = arrayToCSV(newResponse['data'], filters, selectedColumns, columns);
            downloadCSV(str, name);
        } catch (error) {
            // message.error(error);
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};

// export const getIotResourceForDownload = (columns, filters, selectedColumns, name) => {
//     return async (dispatch) => {
//         dispatch(fetchStart());
//         try {
//             const { jobCard } = store.getState();
//             const { iotQuery } = jobCard;
//             const response = await axios.get(`/job-card/download-iot-issues?columns=${columns}&${generateQueryString(iotQuery)}`,
//                 {
//                     responseType: 'stream',
//                     onDownloadProgress: function (progressEvent) {
//                         dispatch(downloadProgress(progressEvent.total, ((progressEvent.loaded / 1024) / 1024).toFixed(2)));
//                     },
//                 });
//             console.log('response:', response.data)
//             dispatch(downloadProgress(0, 0));
//             dispatch(fetchSuccess());
//             const str = arrayToCSV(response.data, filters, selectedColumns, columns);
//             downloadCSV(str, name);
//         } catch (error) {
//             // message.error(error);
//             dispatch(fetchError(error));
//             console.log("Error****:", error);
//         }
//     }
// };

export const geJobDownloadByCurrentStatus = () => {
    return async (dispatch) => {
        dispatch(getDownloadDashboardJobsStart());
        try {
            const response = await axios.get(`/job-card/download-by-current-status`,
                {
                    responseType: 'stream',
                    onDownloadProgress: function (progressEvent) {
                        dispatch(downloadProgress(progressEvent.total, ((progressEvent.loaded / 1024) / 1024).toFixed(2)));
                    },
                });
            dispatch(getDownloadDashboardJobsOk());
            console.log(response.data);
            if (response && response.data) {
                const fileType =
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const fileExtension = '.xlsx';
                let arr = [];
                for (let i = 0; i < response.data.length; i++) {
                    let item = response.data[i];
                    let obj = {};
                    if (moment(item.reviewDate) <= moment(new Date())) {
                        try {
                            obj.JobCardNo = item.jobCardNo || '';
                            obj.AssetCode = item.complaint && item.complaint.asset && item.complaint.asset.assetCode || '';
                            obj.AssetSubType = item.complaint && item.complaint.asset && item.complaint.asset.equipmentSubType
                                && item.complaint.asset.equipmentSubType.name || '';
                            obj.Location = item.complaint && item.complaint.location && item.complaint.location.name || '';
                            obj.SubLocation = item.complaint && item.complaint.client && item.complaint.client.name || '';
                            obj.ComplaintDate = item.complaint && item.complaint.complaintDate && moment(item.complaint.complaintDate).format('DD-MM-YYYY') || '';
                            obj.ReviewDate = item.reviewDate && moment(item.reviewDate).format('DD-MM-YYYY') || '';
                            obj.ExpectedDateOfCompletion = item.expectedDateOfCompletion && moment(item.expectedDateOfCompletion).format('DD-MM-YYYY') || '';
                            obj.PresentStatus = item.changeStatus && item.changeStatus.length && item.changeStatus[item.changeStatus.length - 1]
                                && item.changeStatus[item.changeStatus.length - 1]['status'] && item.changeStatus[item.changeStatus.length - 1]['status']['name'] || '';
                            obj.PresentStatusRemark = item.changeStatus && item.changeStatus.length && item.changeStatus[item.changeStatus.length - 1]
                                && item.changeStatus[item.changeStatus.length - 1]['details'] || '';
                            obj.DetailsOfComplaint = item.complaint && item.complaint.detailsOfComplaint || '';
                            obj.AssetUnservicable = item.complaint && item.complaint.assetUnservicable ? true : false;
                            obj.CauseOfDamage = item.complaint && item.complaint.causeOfDamage || '';
                            obj.AssetType = item.complaint && item.complaint.asset && item.complaint.asset.equipmentSubType && item.complaint.asset.equipmentSubType.assetType && item.complaint.asset.equipmentSubType.assetType.name || '';
                            obj.Complaint = item.complaint && item.complaint.complaintNo || '';
                            obj.CreatedAt = item.createdAt && moment(item.createdAt).format('DD-MM-YYYY') || '';
                            obj.Status = item.status || '';
                            arr.push(obj);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                }
                console.log('arr:', arr)
                const ws = XLSX.utils.json_to_sheet(arr, { cellDates: true, dateNF: 'DD-MM-YYYY' });
                const wb = { Sheets: { report: ws }, SheetNames: ['report'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });
                FileSaver.saveAs(
                    data,
                    `JobReport-${Date.now()}${fileExtension}`,
                );
            }
            dispatch(getDownloadDashboardJobsOk());
        } catch (error) {
            dispatch(getDownloadDashboardJobsOk());
            console.log("Error****:", error);
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
        }
    }
};

export const getDownloadDashboardJobsOk = () => {
    return {
        type: GET_JOB_CARD_DASHBOARD_DOWNLOAD_SUCCESS,
    };
};

export const getDownloadDashboardJobsStart = () => {
    return {
        type: GET_JOB_CARD_DASHBOARD_DOWNLOAD_START
    };
};

// export const getJobCards = () => {
//   return async (dispatch) => {
//     dispatch(fetchStart());
//     try {
//       const { user } = store.getState();
//       const { query } = user;
//       const response = await axios.get(`/job-card?${generateQueryString(query)}`);
//       dispatch(fetchSuccess());
//       dispatch(getJobCardsSuccess(response.data));
//     } catch (error) {
//       dispatch(fetchError(error.response.data.message));
//       console.log('Error****:', error.response.data.message);
//     }
//   };
// };

export const createResource = (payload, source) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.post(`/job-card`, payload);
            dispatch(fetchSuccess());
            dispatch(createResourceSuccess({ data: response.data }));
            openNotification('success', response.data, () => history.push(source === 'complaint' ? '/complaint' : '/job-card'));
            // dispatch(getResource());
        } catch (error) {
            dispatch(fetchError(error));
            console.log('Error****:', error);
        }
    };
};


export const updateResource = (payload, id) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.put(`/job-card/${id}`, payload);
            console.log(response)
            dispatch(fetchSuccess());
            if (response && response.data && response.data.code === 202) {
                message.error(response.data.message);
            }
            // history.push('/job-card');
            // dispatch(getResource());
            history.goBack();
        } catch (error) {
            console.log('Error****:', error);
            dispatch(fetchError(error.response.data.message));
        }
    };
};

export const fetchResource = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.get(`/job-card/${id}`);
            dispatch(fetchSuccess());
            dispatch(fetchResourceSuccess({ data: response.data }));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log('Error****:', error.response.data.message);
        }
    };
};

export const searchResource = (code) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            if (code && code.trim()) {
                const response = await axios.get(`/job-card/search/${code && code.replace(/\//g, '=')}`);
                dispatch(fetchSuccess());
                // dispatch(fetchSearchResourceSuccess({data: response.data}));
                const { data } = response;
                if (data && data._id) {
                    history.push(`/job-card/report/${data._id}`);
                } else {
                    message.error(`No data found!`);
                }
            } else {
                dispatch(fetchSuccess());
            }
        } catch (error) {
            console.log(error.response && error.response.data.message || 'Invalid data - ' + error.toString());
            message.error(error.response && error.response.data.message || 'Invalid data - ' + error.toString());
            dispatch(fetchError(error.response && error.response.data.message || 'Data error - ' + error.toString()));
            // console.log('Error****:', error);
        }
    };
};

export const fetchReport = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.get(`/job-card/report/${id}`);
            const { data } = response;
            if (data && JSON.stringify(data) !== '{}') {
                const acts = await processActivities(data);
                // console.log(acts);
                data['activitiesData']['activities'] = acts;
                // console.log(data);
            }
            dispatch(fetchSuccess());
            dispatch(fetchReportSuccess({ data: data }));
        } catch (error) {
            dispatch(fetchError(error.response && error.response.data.message || 'Data error - ' + error.toString()));
            console.log('Error****:', error);
        }
    };
};

export const fetchJobCardCostingReport = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.post('/job-card/costing-report', payload);
            // console.log('response:', response.data)
            dispatch(fetchSuccess());
            dispatch({
                type: FETCH_JOB_CARD_COSTING_REPORT_SUCCESS,
                data: response.data || []
            });
        } catch (error) {
            dispatch(fetchError(error.response && error.response.data.message || 'Data error - ' + error.toString()));
            message.error(error.response && error.response.data.message || 'Failed to fetch costing report');
            console.log('Error****:', error);
        }
    };
};

const processActivities = (data) => {
    return new Promise((resolve, _) => {
        const activities = (data.activitiesData && data.activitiesData.activities || []).map(async (act) => {
            if (act && act.isOfTransferType) {
                const doc = await axios.get(`/sub-asset-transfer/by-activity/${act._id}`);
                return { ...act, ...{ sat: doc.data } };
            } else {
                return { ...act };
            }
        });
        Promise.all(activities)
            .then((act) => resolve(act))

    });
};

export const deleteResource = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.delete(`/job-card/${id}`);
            dispatch(fetchSuccess());
            if (response && response.data && response.data.code === 202) {
                message.error(response.data.message);
            }
            dispatch(getResource());
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log('Error****:', error.response.data.message);
        }
    };
};

export const cancelJCWithDateAndRemark = (id, payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.put(`job-card/cancel-job-card-remark/${id}`, payload);
            if (response) {
                dispatch(fetchSuccess());
                if (response && response.data && response.data.code && response.data.code === '201') {
                    message.success(response.data.message);
                } else if (response && response.data && response.data.code && response.data.code === '401') {
                    message.error(response.data.message);
                } else {
                    message.error('Can\'t Cancel...!');
                }
                // history.push('/job-card');
                // dispatch(getResource());
                dispatch(fetchReport(id));
            } else {
                console.log('res', response);
            }
        } catch (error) {
            console.log('Error****:', error);
            dispatch(fetchError(error.response.data.message));
        }
    };
};

export const unCancelledJobCard = (id, payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.put(`job-card/uncancelledJobCard/${id}`, payload);
            if (response) {
                dispatch(fetchSuccess());
                if (response && response.data && response.data.code && response.data.code === '201') {
                    message.success(response.data.message);
                } else if (response && response.data && response.data.code && response.data.code === '401') {
                    message.error(response.data.message);
                } else {
                    message.error('Can\'t Cancel...!');
                }
                // history.push('/job-card');
                // dispatch(getResource());
                dispatch(fetchReport(id));
            } else {
                console.log('res', response);
            }
        } catch (error) {
            console.log('Error****:', error);
            dispatch(fetchError(error.response.data.message));
        }
    };
};

export const updateJobCardWithDocument = (id, payload) => {
    let data;
    if (payload.length > 0) {
        data = payload[payload.length - 1];
    } else {
        data = payload[0];
    }

    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const formData = new FormData();
            formData.append('data', JSON.stringify(data));
            formData.append('files', data.file);
            await axios.put(`common/updateJobCardWithDocument/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            dispatch(fetchReport(id));
            dispatch(fetchSuccess());
        } catch (error) {
            console.log('Error****:', error);
            dispatch(fetchError(error.response.data.message));
        }
    };
};

export const getAllJobs = (status) => {
    return async dispatch => {
        dispatch(getAllJobsStart());
        try {
            const response = await axios.get(`/job-card/organisation/all/${status}`);
            dispatch(getAllJobsOk({ data: response.data }));
        } catch (error) {
            dispatch(getAllJobsOk({ data: [] }));
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const getAllOpenJobs = (status) => {
    return async dispatch => {
        dispatch(getAllJobsStart());
        try {
            const response = await axios.get(`/job-card/organisation/all/${status}`);
            dispatch(getAllOpenJobsOk({ data: response.data }));
        } catch (error) {
            dispatch(getAllOpenJobsOk({ data: [] }));
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const getAllOpenJobsByCurrentStatus = (payload = {}) => {
    return async dispatch => {
        dispatch(getAllJobsStart());
        try {
            const response = await axios.post(`/job-card/current-status`, { ...payload, today: moment().valueOf() });
            // console.log(response);
            dispatch(getAllOpenJobsOk({ data: response.data }));
        } catch (error) {
            dispatch(getAllOpenJobsOk({ data: [] }));
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    };
};

export const getAllOpenJobsOk = ({ data }) => {
    return {
        type: GET_ALL_OPEN_JOBS_SUCCESS,
        data
    };
};

export const getAllJobsOk = ({ data }) => {
    return {
        type: GET_ALL_JOBS_SUCCESS,
        data
    };
};

export const getAllJobsStart = () => {
    return {
        type: GET_ALL_JOBS_START
    };
};

const openNotification = (alertType, jobCard, callback) => {
    new Promise((resolve, _) => {
        const complaint = (jobCard && jobCard.complaint || {});
        const asset = (complaint && complaint.asset || {});
        const jobCardNo = jobCard && jobCard.jobCardNo;
        const assetCode = asset && asset.assetCode;
        const ownerCode = asset && asset.ownerCode;
        const altName = asset && asset.altName;
        const assetLabel = [assetCode, altName, ownerCode].filter(Boolean).join(' / ');
        const assetType = asset && asset.equipmentSubType && asset.equipmentSubType.assetType && asset.equipmentSubType.assetType.name;
        const assetModel = asset && asset.assetModel && asset.assetModel.name;
        const location = complaint && complaint.location && complaint.location.name;
        const subLocation = complaint && complaint.client && complaint.client.name;
        const expectedDateOfCompletion = jobCard && jobCard.expectedDateOfCompletion && moment(jobCard.expectedDateOfCompletion).format('DD-MM-YYYY');
        const complaintNo = complaint && complaint.complaintNo;
        const complaintDate = complaint && complaint.complaintDate && moment(complaint.complaintDate).format('DD-MM-YYYY');
        const causeOfDamage = complaint && complaint.causeOfDamage;
        const complaintDetail = complaint && complaint.detailsOfComplaint;
        notification[alertType]({
            duration: 30,
            message: alertType === 'success' ? <><Title level={4}>Job Card {jobCard.jobCardNo} created
                successfully</Title></> : 'Notification',
            description: (<>
                <Paragraph copyable={{
                    tooltips: ['Click to copy', 'Copied'],
                    text: `*Job Card No. :* ${jobCardNo}\n*Asset :* ${assetLabel}\n*Asset Type :* ${assetType}\n*Model :* ${assetModel}\n*Location :* ${location}\n*Sub Location :* ${subLocation}\n*Expected Completion Date :* ${expectedDateOfCompletion}\n*Complaint No. :* ${complaintNo}\n*Complaint Date :* ${complaintDate}\n*Cause of Damage :* ${causeOfDamage}\n*Complaint Details :* ${complaintDetail}`
                }}>
                    <Text strong>Job Card No. : </Text><Text>{jobCardNo}</Text><br />
                    <Text strong>Asset : </Text><Text>{assetLabel}</Text><br />
                    <Text strong>Asset Type : </Text><Text>{assetType}</Text><br />
                    <Text strong>Model : </Text><Text>{assetModel}</Text><br />
                    <Text strong>Location : </Text><Text>{location}</Text><br />
                    <Text strong>Sub Location : </Text><Text>{subLocation}</Text><br />
                    <Text strong>Expected Completion Date : </Text><Text>{expectedDateOfCompletion}</Text><br />
                    <Text strong>Complaint No. : </Text><Text>{complaintNo}</Text><br />
                    <Text strong>Complaint Date : </Text><Text>{complaintDate}</Text><br />
                    <Text strong>Cause of Damage : </Text><Text>{causeOfDamage}</Text><br />
                    <Text strong>Complaint Details : </Text><Text>{complaintDetail}</Text>
                </Paragraph>
            </>),
            style: {
                width: 700,
                marginLeft: 335 - 700,
            }
        });
        // console.log(`Resolved`);
        resolve();
    }
    ).then(callback);
};

export const uploadJobCards = (formData) => {
    // console.log(formData);
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.post(`common/upload/create-job-cards`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            // console.log(response.data);
            const uploadData = response.data.filter(doc => doc);
            // downloadFile(uploadData);
            downloadJCResponseFile(uploadData);
            dispatch(fetchSuccess());
        } catch (error) {
            message.error(`Upload error, contact admin`);
            console.log('Error****:', error);
            dispatch(fetchError(error));
        }
    };
};

const downloadFile = (myData, name = "job-upload.log") => {
    const fileName = name;
    const json = JSON.stringify(myData, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const href = URL.createObjectURL(blob);
    // create "a" HTLM element with href to file
    const link = document.createElement("a");
    link.href = href;
    link.download = fileName + ".json";
    document.body.appendChild(link);
    link.click();
    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};

const downloadJCResponseFile = myData => {
    let count = 0;
    const dataPromise = (myData || []).map(async doc => {
        const { item, complaint, job } = doc;
        let obj = { ...item };
        if (complaint && complaint.complaintNo) {
            obj['ComplaintNo'] = complaint.complaintNo;
            count += 1;
        }

        if (job && job.jobCardNo) {
            obj['JobCardNo'] = job.jobCardNo;
            if (job.activities && job.activities.length > 0) {
                job.activities.map((act, index) => {
                    obj[`Activity ${index + 1} No`] = act.activitySerialNo;
                });
            }
        }
        return obj;
    });

    Promise.all(dataPromise).then(xlsData => {
        message.success(`Upload is successful ${count} records uploaded`);
        const fileType =
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(xlsData);
        const wb = { Sheets: { report: ws }, SheetNames: ['report'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(
            data,
            `JCBulkUploadResponse-${Date.now()}${fileExtension}`,
        );
    });
};
